export default __webpack_public_path__ + "static/media/download_circle_thin_icon.92f7e55c.svg";